import { Controller } from "@hotwired/stimulus"

import Cookies from "js-cookie";

// Connects to data-controller="favorite"
export default class extends Controller {
  connect() {
    this.element.dataset.action = 'favorite#toggle'
  }

  toggle(e) {
    e.preventDefault()

    let icon = this.element.querySelector('.icon');

    ['gray', 'red'].forEach(color => icon.classList.toggle(`icon--${color}`))

    Cookies.set('bridge', 'refresh#dashboard', { expires: (new Date().getTime() + 2000) })

    fetch(this.element.href)
  }
}
